<template>
    <div class="stage-title"
         :style="`background: ${active_stage.color}`">

        <img class="bottom-curve" src="/images/utils/curve-heading.webp" alt="">

        <div class="container-fluid">
            <div class="head">
                <div class="stage-icon">
                    <img :src="active_stage.icon" :alt="active_stage.title">
                </div>
                <div class="stage-description">
                    <div class="step">Step 1</div>
                    {{ active_stage.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StageTitle",

    props: {
        modelValue: {
            type: [String, Number],
        },
        stages: {
            type: [Object, Array],
        }
    },


    computed: {
        active_stage(){
            return this.stages[this.modelValue];
        }
    }

}
</script>

<style lang="scss" scoped>
.stage-title{
    padding-bottom: 8rem;
    position: relative;
}

.bottom-curve{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
}

.head{
    display: flex;
    align-items: center;
    padding: 4rem 0;
}

.stage-icon{
    flex: 0 0 240px;
    padding: 1rem 1rem 1rem 0;

    img{
        width: 100%;
        height: auto;
    }
}

.stage-description{
    flex: 1 1 auto;
    font-size: 2.8rem;
    color: white;
    font-weight: $font-weight-bold;
    max-width: 640px;
    line-height: 1.2;

    .step{
        opacity: 0.7;
        font-size: 0.85em;
    }
}
</style>
